export const PAYPAL_COUNTRY_CODES = [
  { code: 'AF', names: { 'PL': 'Afganistan', 'EN': 'Afghanistan' } },
  { code: 'AL', names: { 'PL': 'Albania', 'EN': 'Albania' } },
  { code: 'DZ', names: { 'PL': 'Algieria', 'EN': 'Algeria' } },
  { code: 'AD', names: { 'PL': 'Andora', 'EN': 'Andorra' } },
  { code: 'AO', names: { 'PL': 'Angola', 'EN': 'Angola' } },
  { code: 'AG', names: { 'PL': 'Antigua i Barbuda', 'EN': 'Antigua and Barbuda' } },
  { code: 'AR', names: { 'PL': 'Argentyna', 'EN': 'Argentina' } },
  { code: 'AM', names: { 'PL': 'Armenia', 'EN': 'Armenia' } },
  { code: 'AU', names: { 'PL': 'Australia', 'EN': 'Australia' } },
  { code: 'AT', names: { 'PL': 'Austria', 'EN': 'Austria' } },
  { code: 'AZ', names: { 'PL': 'Azerbejdżan', 'EN': 'Azerbaijan' } },
  { code: 'BH', names: { 'PL': 'Bahrajn', 'EN': 'Bahrain' } },
  { code: 'BD', names: { 'PL': 'Bangladesz', 'EN': 'Bangladesh' } },
  { code: 'BY', names: { 'PL': 'Białoruś', 'EN': 'Belarus' } },
  { code: 'BE', names: { 'PL': 'Belgia', 'EN': 'Belgium' } },
  { code: 'BZ', names: { 'PL': 'Belize', 'EN': 'Belize' } },
  { code: 'BJ', names: { 'PL': 'Benin', 'EN': 'Benin' } },
  { code: 'BT', names: { 'PL': 'Bhutan', 'EN': 'Bhutan' } },
  { code: 'BO', names: { 'PL': 'Boliwia', 'EN': 'Bolivia' } },
  { code: 'BA', names: { 'PL': 'Bośnia i Hercegowina', 'EN': 'Bosnia and Herzegovina' } },
  { code: 'BW', names: { 'PL': 'Botswana', 'EN': 'Botswana' } },
  { code: 'BR', names: { 'PL': 'Brazylia', 'EN': 'Brazil' } },
  { code: 'BG', names: { 'PL': 'Bułgaria', 'EN': 'Bulgaria' } },
  { code: 'CA', names: { 'PL': 'Kanada', 'EN': 'Canada' } },
  { code: 'CL', names: { 'PL': 'Chile', 'EN': 'Chile' } },
  { code: 'CN', names: { 'PL': 'Chiny', 'EN': 'China' } },
  { code: 'CO', names: { 'PL': 'Kolumbia', 'EN': 'Colombia' } },
  { code: 'CR', names: { 'PL': 'Kostaryka', 'EN': 'Costa Rica' } },
  { code: 'HR', names: { 'PL': 'Chorwacja', 'EN': 'Croatia' } },
  { code: 'CY', names: { 'PL': 'Cypr', 'EN': 'Cyprus' } },
  { code: 'CZ', names: { 'PL': 'Czechy', 'EN': 'Czech Republic' } },
  { code: 'DK', names: { 'PL': 'Dania', 'EN': 'Denmark' } },
  { code: 'DO', names: { 'PL': 'Dominikana', 'EN': 'Dominican Republic' } },
  { code: 'EG', names: { 'PL': 'Egipt', 'EN': 'Egypt' } },
  { code: 'EE', names: { 'PL': 'Estonia', 'EN': 'Estonia' } },
  { code: 'FI', names: { 'PL': 'Finlandia', 'EN': 'Finland' } },
  { code: 'FR', names: { 'PL': 'Francja', 'EN': 'France' } },
  { code: 'GE', names: { 'PL': 'Gruzja', 'EN': 'Georgia' } },
  { code: 'DE', names: { 'PL': 'Niemcy', 'EN': 'Germany' } },
  { code: 'GR', names: { 'PL': 'Grecja', 'EN': 'Greece' } },
  { code: 'HU', names: { 'PL': 'Węgry', 'EN': 'Hungary' } },
  { code: 'IS', names: { 'PL': 'Islandia', 'EN': 'Iceland' } },
  { code: 'IN', names: { 'PL': 'Indie', 'EN': 'India' } },
  { code: 'ID', names: { 'PL': 'Indonezja', 'EN': 'Indonesia' } },
  { code: 'IE', names: { 'PL': 'Irlandia', 'EN': 'Ireland' } },
  { code: 'IL', names: { 'PL': 'Izrael', 'EN': 'Israel' } },
  { code: 'IT', names: { 'PL': 'Włochy', 'EN': 'Italy' } },
  { code: 'JP', names: { 'PL': 'Japonia', 'EN': 'Japan' } },
  { code: 'KR', names: { 'PL': 'Korea Południowa', 'EN': 'South Korea' } },
  { code: 'LV', names: { 'PL': 'Łotwa', 'EN': 'Latvia' } },
  { code: 'LT', names: { 'PL': 'Litwa', 'EN': 'Lithuania' } },
  { code: 'LU', names: { 'PL': 'Luksemburg', 'EN': 'Luxembourg' } },
  { code: 'MY', names: { 'PL': 'Malezja', 'EN': 'Malaysia' } },
  { code: 'MT', names: { 'PL': 'Malta', 'EN': 'Malta' } },
  { code: 'MX', names: { 'PL': 'Meksyk', 'EN': 'Mexico' } },
  { code: 'MD', names: { 'PL': 'Mołdawia', 'EN': 'Moldova' } },
  { code: 'MC', names: { 'PL': 'Monako', 'EN': 'Monaco' } },
  { code: 'ME', names: { 'PL': 'Czarnogóra', 'EN': 'Montenegro' } },
  { code: 'MA', names: { 'PL': 'Maroko', 'EN': 'Morocco' } },
  { code: 'NL', names: { 'PL': 'Holandia', 'EN': 'Netherlands' } },
  { code: 'NZ', names: { 'PL': 'Nowa Zelandia', 'EN': 'New Zealand' } },
  { code: 'NG', names: { 'PL': 'Nigeria', 'EN': 'Nigeria' } },
  { code: 'NO', names: { 'PL': 'Norwegia', 'EN': 'Norway' } },
  { code: 'PK', names: { 'PL': 'Pakistan', 'EN': 'Pakistan' } },
  { code: 'PE', names: { 'PL': 'Peru', 'EN': 'Peru' } },
  { code: 'PH', names: { 'PL': 'Filipiny', 'EN': 'Philippines' } },
  { code: 'PL', names: { 'PL': 'Polska', 'EN': 'Poland' } },
  { code: 'PT', names: { 'PL': 'Portugalia', 'EN': 'Portugal' } },
  { code: 'RO', names: { 'PL': 'Rumunia', 'EN': 'Romania' } },
  { code: 'RU', names: { 'PL': 'Rosja', 'EN': 'Russia' } },
  { code: 'SA', names: { 'PL': 'Arabia Saudyjska', 'EN': 'Saudi Arabia' } },
  { code: 'RS', names: { 'PL': 'Serbia', 'EN': 'Serbia' } },
  { code: 'SG', names: { 'PL': 'Singapur', 'EN': 'Singapore' } },
  { code: 'SK', names: { 'PL': 'Słowacja', 'EN': 'Slovakia' } },
  { code: 'SI', names: { 'PL': 'Słowenia', 'EN': 'Slovenia' } },
  { code: 'ZA', names: { 'PL': 'Republika Południowej Afryki', 'EN': 'South Africa' } },
  { code: 'ES', names: { 'PL': 'Hiszpania', 'EN': 'Spain' } },
  { code: 'SE', names: { 'PL': 'Szwecja', 'EN': 'Sweden' } },
  { code: 'CH', names: { 'PL': 'Szwajcaria', 'EN': 'Switzerland' } },
  { code: 'TH', names: { 'PL': 'Tajlandia', 'EN': 'Thailand' } },
  { code: 'TR', names: { 'PL': 'Turcja', 'EN': 'Turkey' } },
  { code: 'UA', names: { 'PL': 'Ukraina', 'EN': 'Ukraine' } },
  { code: 'AE', names: { 'PL': 'Zjednoczone Emiraty Arabskie', 'EN': 'United Arab Emirates' } },
  { code: 'GB', names: { 'PL': 'Wielka Brytania', 'EN': 'United Kingdom' } },
  { code: 'US', names: { 'PL': 'Stany Zjednoczone', 'EN': 'United States' } },
  { code: 'VN', names: { 'PL': 'Wietnam', 'EN': 'Vietnam' } }
]
